import React from 'react';

import FailedRecording from 'assets/images/svgs/Recording/ico_failed_recording.svg';
import FailedRecordingBlack from 'assets/images/svgs/Recording/ico_failed_recording_black.svg';

type Props = { highlighted: boolean; size: number };

function FailedSingleRecording({ highlighted, size }: Props) {
    return highlighted ? (
        <FailedRecordingBlack width={size} height={size} />
    ) : (
        <FailedRecording width={size} height={size} />
    );
}

export default FailedSingleRecording;
